import {
  ControlBuildIcon,
  HeartFilledIcon,
  HelpIcon,
  IconSize,
  SadIcon,
  StatusBanIcon,
  StatusErrorIcon,
  SuccessCircleIcon,
  ThumbUpIcon,
} from '../assets/Icons'
import { Colors } from '../global/colors'
import { ModalVisualMode } from './ModalTypes'

export const getIcon = (mode: ModalVisualMode) => {
  switch (mode) {
    case ModalVisualMode.Plain:
      return undefined
    case ModalVisualMode.Encouragement:
      return <ThumbUpIcon size={IconSize.MEDIUM} style={{ color: Colors.ElementMediumPrimary }} />
    case ModalVisualMode.Check:
      return <SuccessCircleIcon size={IconSize.MEDIUM} />
    case ModalVisualMode.ExtraCautious:
      return <StatusErrorIcon size={IconSize.MEDIUM} style={{ color: Colors.ElementError }} />
    case ModalVisualMode.Happy:
      return <HeartFilledIcon size={IconSize.MEDIUM} style={{ color: Colors.ElementMediumSecondary }} />
    case ModalVisualMode.Think:
    case ModalVisualMode.ThinkTwice:
      return <HelpIcon />
    case ModalVisualMode.TechnicalError:
      return <ControlBuildIcon size={IconSize.MEDIUM} style={{ color: Colors.ElementMediumNeutral }} />
    case ModalVisualMode.NoAccess:
      return <StatusBanIcon size={IconSize.MEDIUM} style={{ color: Colors.ElementMediumNeutral }} />
    case ModalVisualMode.Sympathy:
      return <SadIcon style={{ color: Colors.ElementMediumNeutral }} />
    default: {
      const _exhaustiveCheck: never = mode
      return _exhaustiveCheck
    }
  }
}
